import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateCropMixComposerCommercialMixes } from "services";

import { EXPORT_CROP_MIX_COMPOSER_COMMERCIAL_MIXES, UPDATE_CROP_MIX_COMPOSER_COMMERCIAL_MIXES } from "consts";

export const useUpdateCropMixComposerCommercialMixes = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UPDATE_CROP_MIX_COMPOSER_COMMERCIAL_MIXES],
    mutationFn: updateCropMixComposerCommercialMixes,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [EXPORT_CROP_MIX_COMPOSER_COMMERCIAL_MIXES] });
    },
  });
};
